import AlisverisIcon from "assets/svg/map/poi-filter-icon/alisveris.svg";
import DiniYerlerIcon from "assets/svg/map/poi-filter-icon/dini_yerler.svg";
import EgitimIcon from "assets/svg/map/poi-filter-icon/egitim_kurumlari.svg";
import EglenceIcon from "assets/svg/map/poi-filter-icon/eglence.svg";
import KafeIcon from "assets/svg/map/poi-filter-icon/kafe.svg";
import KulturelYerlerIcon from "assets/svg/map/poi-filter-icon/kulturel_yerler.svg";
import MarketlerIcon from "assets/svg/map/poi-filter-icon/marketler.svg";
import SaglikIcon from "assets/svg/map/poi-filter-icon/saglik_kurumlari.svg";
import SporIcon from "assets/svg/map/poi-filter-icon/spor.svg";
import TarihiYerlerIcon from "assets/svg/map/poi-filter-icon/tarihi_yerler.svg";
import UlasimIcon from "assets/svg/map/poi-filter-icon/ulasim.svg";

const iconSet = [
  {
    id: 1,
    icon: <AlisverisIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/alisveris.svg",
  },
  {
    id: 2,
    icon: <EgitimIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/egitim_kurumlari.svg",
  },
  {
    id: 3,
    icon: <EglenceIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/eglence.svg",
  },
  {
    id: 4,
    icon: <DiniYerlerIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/dini_yerler.svg",
  },
  {
    id: 5,
    icon: <KafeIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/kafe.svg",
  },
  {
    id: 6,
    icon: <KulturelYerlerIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/kulturel_yerler.svg",
  },
  {
    id: 7,
    icon: <MarketlerIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/marketler.svg",
  },
  {
    id: 8,
    icon: <SaglikIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/saglik_kurumlari.svg",
  },
  {
    id: 9,
    icon: <SporIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/spor.svg",
  },
  {
    id: 10,
    icon: <TarihiYerlerIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/tarihi_yerler.svg",
  },
  {
    id: 11,
    icon: <UlasimIcon />,
    iconUrl: "/assets/icons/map/poi-placemark-icon/ulasim.svg",
  },
];

export default iconSet;
